var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.waveform[data-v-09b11a02] {\n  background-position: bottom left;\n  background-image: url(" + escape(require("@/assets/interactive-waveform-desktop.svg")) + ");\n  background-repeat: repeat-x;\n}\n.ml174[data-v-09b11a02] {\n  margin-left: 174px;\n}\n", ""]);

// exports
